import * as React from "react"
import constants from "subfeatures/RegionSelectionPage/constants"

export const getRegionAbbrevValueMapping = () => {
    const regionAbbrevValueMapping = {}
    DjangIO.app.models.SupportedRegion.items().forEach((region) => {
        regionAbbrevValueMapping[region.abbrev] = region.value
    })
    return regionAbbrevValueMapping
}

// using existing logic to get the icon and name for the current region to
// use in the left part of the top bar. TODO: derive straight from the Region enum in the future
export const getCurrentRegionIcon = () => {
    const regionAbbrevValueMapping = getRegionAbbrevValueMapping()

    let currentRegionIcon
    let currentRegionName

    // will have a current_preset_name if user is in a custom region
    if (Userdata.current_preset_name) {
        currentRegionIcon = constants.topcustomIcon
        currentRegionName = Userdata.current_preset_name
    }
    // major region groupins
    else if (Userdata.isOnlyFederalMode()) {
        currentRegionIcon = constants.topfederalIcon
        currentRegionName = 'Federal'
    } else if (Userdata.isFederalMode()) {
        currentRegionIcon = constants.allIcon
        currentRegionName = 'Entire US'
    } else if (Userdata.isAllStateAndLocalMode()) {
        currentRegionIcon = constants.topstatesIcon
        currentRegionName = "States & Local"
    } else if (Userdata.isGlobalMode()) {
        currentRegionIcon = constants.globalIcon
        currentRegionName = "Global"
    } else if (Userdata.isInternationalMode()) {
        currentRegionIcon = constants.internationalIcon
        currentRegionName = "International"
    } else if (Userdata.isEUMemberStates()) {
        currentRegionIcon = constants.topEUIcon
        currentRegionName = DjangIO.app.models.SupportedRegion.eu_member_states.region_name
    }
    // single/sub regions
    else if (Userdata.isSingleRegionMode()) {
        if (Userdata.current_regions[0] === "eu") {
            currentRegionIcon = constants.topEUIcon
            currentRegionName = "European Union"
        }
        else if (Userdata.current_regions[0].replace('_local', '').length == 2) {
            currentRegionIcon = <span className={`stateface stateface-${Userdata.current_regions[0].replace('_local', '')}`} />
            currentRegionName = DjangIO.app.models.SupportedRegion.by_value(regionAbbrevValueMapping[Userdata.current_regions[0]]).region_name
        }
        else {
            currentRegionIcon = undefined
            currentRegionName = DjangIO.app.models.SupportedRegion.by_value(regionAbbrevValueMapping[Userdata.current_regions[0]]).region_name
        }
    } else if (Userdata.isSubsetMode()) {
        currentRegionIcon = constants.topstatesIcon
        currentRegionName = Userdata.current_regions.map(item => item.toUpperCase()).join(", ")
    } else if (Userdata.isAllStatesMode()) {
        currentRegionIcon = constants.topstatesIcon
        currentRegionName = "States"
    } else if (Userdata.isAllLocalMode()) {
        currentRegionIcon = constants.toplocalIcon
        currentRegionName = "Local"
    }

    return {
        currentRegionIcon,
        currentRegionName
    }
}

const helperFunctions = {
    getCurrentRegionIcon
}

export default helperFunctions
